var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.instance)?_c('MenuForm',{attrs:{"value":_vm.instance,"breadcrumbs":_vm.breadcrumbs},scopedSlots:_vm._u([{key:"actions",fn:function(ref){
var form = ref.form;
var fields = ref.fields;
var isEqual = ref.isEqual;
return [_c('VButtonDialog',{on:{"confirm":function($event){return _vm.remove(fields)}}},[_vm._v(" Delete ")]),_c('v-btn',{staticClass:"mx-2",attrs:{"disabled":!form || isEqual,"color":"success","rounded":""},on:{"click":function($event){return _vm.update(fields)}}},[_vm._v(" Save ")])]}}],null,false,1046505787)}):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }